// src/App.js

import React, { useState } from "react";
import Login from "./Login"; // ✅ Login component
import BillingSystem from "./BillingSystem"; // ✅ Billing system
import OwnerAddUser from "./OwnerAddUser"; // ✅ Owner user management
import ProductionPage from "./ProductionPage"; // ✅ Production manager page
import RawStockPage from "./RawStockPage"; // ✅ Stock manager page

export default function App() {
  const [user, setUser] = useState(null);

  if (!user) return <Login onLogin={setUser} />;

  const handleLogout = () => setUser(null);

  return (
    <div style={{ padding: 20 }}>
      <div style={{ marginBottom: 20 }}>
        <p>Logged in as <strong>{user.phone}</strong> ({user.role})</p>
        <button onClick={handleLogout}>Logout</button>
      </div>

      {/* Owner can add users */}
      {user.role === "owner" && <OwnerAddUser />}

      {/* Show correct page based on role */}
      {user.role === "production" && (
        <ProductionPage role={user.role} phone={user.phone} />
      )}

      {user.role === "stock manager" && (
        <RawStockPage role={user.role} />
      )}

      {["staff", "manager", "owner"].includes(user.role) && (
        <BillingSystem role={user.role} phone={user.phone} />
      )}
    </div>
  );
}
